<div class="p-8">
  <div class="flex items-center justify-between">
    <h1 translate class="text-xl font-normal text-theme-950">trilhas.estudio.colecao</h1>
  </div>
  <div class="-mx-24 my-5 border border-theme-500"></div>
  <form [formGroup]="form">
    <app-form-field>
      <label app-label translate class="text-2xl text-theme-950">trilhas.estudio.nome-colecao</label>
      <input
        app-input
        formControlName="nome"
        class="block leading-5"
        type="text"
        [placeholder]="'trilhas.estudio.defina-nome-colecao' | translate"
      />
    </app-form-field>
    <app-form-field>
      <label app-label translate class="text-2xl text-theme-950">trilhas.estudio.autor</label>
      <input
        app-input
        formControlName="autor"
        class="block leading-5"
        type="text"
        [placeholder]="'trilhas.estudio.defina-nome-autor' | translate"
      />
    </app-form-field>
    <div class="flex flex-col items-start justify-center gap-6">
      <div *isAllow="[18, 32]" class="flex w-full flex-col items-start gap-2">
        <ng-container *ngIf="isCPB">
          <label app-label class="!p-0 !text-base" translate>trilhas.estudio.produzido-cpb</label>
          <app-switch formControlName="cpb" [colorTrue]="'bg-theme-300'"></app-switch>
        </ng-container>
      </div>
      <div class="flex w-full flex-col items-start gap-2">
        <div class="flex items-center justify-center gap-2">
          <label app-label class="!p-0 !text-base" translate>trilhas.estudio.destaque</label>
          <div
            app-tooltip
            [tooltip]="'trilhas.estudio.tooltip-destaque' | translate"
            class="flex h-[13px] w-[13px] cursor-pointer items-center justify-center rounded-full border border-black"
          >
            <span class="text-center text-[10px]">&quest;</span>
          </div>
        </div>
        <app-switch formControlName="destaque" [colorTrue]="'bg-theme-300'"></app-switch>
      </div>
    </div>
    <div class="mt-8 flex w-full items-center justify-end gap-5">
      <button
        type="button"
        (click)="onClose()"
        app-outline-button
        translate
        class="!h-10 w-1/2 border-base-status-danger text-base-status-danger hover:[&:not([disabled])]:bg-base-status-danger hover:[&:not([disabled])]:text-theme-contrast"
      >
        trilhas.cancelar
      </button>
      <button
        type="button"
        (click)="onSave()"
        app-outline-button
        translate
        class="!h-10 w-1/2 border-theme-800 text-theme-800 hover:[&:not([disabled])]:bg-theme-800 hover:[&:not([disabled])]:text-theme-contrast"
      >
        trilhas.salvar
      </button>
    </div>
  </form>
</div>
